import {
    SEARCHINGSKU,
    SENDINGDATA,
    SEARCHINGSKUGALERIA,
    DADOSGALERIA,
    URLSVITRINE,
    CODPARCVITRINESEARCH,
    CRIAVITRINELOADING,
    NOVOCLIENTE_CHANGETAB,
    LASTSKUSEACRH,
    LISTAPROVACAO,
    APROVACAOSENDLOADING,
    LISTAPROVACAOLOADING,
    ATRIBUTOSLIST,
    ATRIBUTOSLISTLOADING,
    ATRIBUTOSITEMLIST,
    ATRIBUTOSITEMLISTLOADING,
    DELETEATRIBUTOSITEMLIST,
    DELETEATRIBUTOSITEMLISTLOADING,
    POSTATRIBUTOADDNEW,
    POSTATRIBUTOADDNEWLOADING,
    DELETEATRIBUTO,
    DELETEATRIBUTOLOADING,
    EDITATRIBUTOLOADING,
    EDITATRIBUTO,
    CHANGETAB,
    SET_ATRIBUTO_SELECIONADO,
    ATRIBUTOSAPLICARLIST,
    ATRIBUTOSAPLICARLISTLOADING,
    ATRIBUTOSAPLICARGERAL,
    ATRIBUTOSAPLICARGERALLOADING,
    ATRIBUTOSAPLICARDELETE,
    ATRIBUTOSAPLICARDELETELOADING,
    ATRIBUTOSAPLICAREDIT,
    ATRIBUTOSAPLICAREDITLOADING,
    FABRICANTELIST,
    FABRICANTELISTLOADING,
    CLASSIFICACAOLIST,
    CLASSIFICACAOLISTLOADING,
    MARCALIST,
    MARCALISTLOADING,
    LINHALIST,
    LINHALISTLOADING,
    SECAOLIST,
    SECAOLISTLOADING,
    CONTEUDOLIST,
    CONTEUDOLISTLOADING,
    CONTEUDOBUSCA,
    CONTEUDOBUSCALOADING,
    CONTEUDOAPLICALOADING,
    CONTEUDOAPLICA,
    SECAOSKULIST,
    SECAOSKULISTLOADING,
    UPDATEDESCCONTEUDO,
    UPDATEDESCCONTEUDOLOADING,
    UPDATETITULOCONTEUDO,
    UPDATETITULOCONTEUDOLOADING,
    ADDTITULOCONTEUDOLOADING,
    ADDTITULOCONTEUDO,
    DELETETITULOCONTEUDO,
    DELETETITULOCONTEUDOLOADING,
    CONTEUDODETALHES,
    CONTEUDODETALHESLOADING,
    BUSCASKU,
    BUSCASKULOADING,
    BUSCASKULASTSKU,
    APLICARESTLIST,
    APLICARESTLISTLOADING,
    APLICARESTBUSCALIST,
    APLICARESTBUSCALISTLOADING,
    APLICARESTAPLICA,
    APLICARESTAPLICALOADING

} from '../actions/ActionsTypes'


const INITIAL_STATE = {
    isSearching: false,
    isSending: false,
    isSearchingGaleria: false,
    dadosGaleria: [],
    urlsVitrine: [],
    isSearchingCodparc: false,
    isLoadingCriaVitrine: false,
    tabindex: 0,
    lastSKUsearch: '',
    aprovacaoList: [],
    isLoadingAprovacaoSend: false,
    aprovacaoListLoading: false,
    atributosList: [],
    atributosListLoading: false,
    atributosItemList: [],
    atributosItemListLoading: false,
    deleteAtributosItemList: [],
    deleteAtributosItemListLoading: false,
    editAtributo: [],
    editAtributoLoading: false,
    deleteAtributo: [],
    deleteAtributoLoading: false,
    postAtributoAddNew: [],
    postAtributoAddNewLoading: false,
    atributoSelecionado: null,
    atributosAplicarList: [],
    atributosAplicarListLoading: false,
    atributosAplicarGeral: [],
    atributosAplicarGeralLoading: false,
    atributosAplicarDelete: [],
    atributosAplicarDeleteLoading: false,
    atributosAplicarEdit: [],
    atributosAplicarEditLoading: false,
    fabricanteList: [],
    fabricanteListLoading: false,
    classificacaoList: [],
    classificacaoListLoading: false,
    marcaList: [],
    marcaListLoading: false,
    linhalist: [],
    linhalistLoading: false,
    secaolist: [],
    secaolistLoading: false,
    secaoskulist: [],
    secaoskulistLoading: false,
    buscaSku: {
        infoProduto: [],
        atributos: [],
        conteudoSecao: [],
        html: []
    },
    buscaSkuLastSku: '',
    buscaSkuLoading: false,
    conteudolist: [],
    conteudolistLoading: false,
    conteudobusca: [],
    conteudobuscaLoading: false,
    conteudodetalhes: [],
    conteudodetalhesLoading: false,
    conteudoaplica: [],
    conteudoaplicaLoading: false,
    updatedesc: [],
    updatedescloading: false,
    updatetitulo: [],
    updatetituloloading: false,
    addtitulo: [],
    addtituloloading: false,
    deletetitulo: [],
    deletetituloloading: false,
    aplicarest: [],
    aplicarlistloading: false,
    aplicarestbusca: [],
    aplicarbuscalistloading: false,
    aplicarestaplica: [],
    aplicarestaplicaloading: false
}


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case SEARCHINGSKU:
            return { ...state, isSearching: action.payload }


        case SENDINGDATA:
            return { ...state, isSending: action.payload }

        case SEARCHINGSKUGALERIA:
            return { ...state, isSearchingGaleria: action.payload }

        case DADOSGALERIA:
            return { ...state, dadosGaleria: action.payload }

        case URLSVITRINE: {
            const exists = state.urlsVitrine.some(
                (i) => i.url === action.payload.url
            );

            return {
                ...state,
                urlsVitrine: exists
                    ? state.urlsVitrine.filter((i) => i.url !== action.payload.url)
                    : [...state.urlsVitrine, action.payload] // adiciona { url, sku }
            };
        }


        case CODPARCVITRINESEARCH:
            return { ...state, isSearchingCodparc: action.payload }

        case LASTSKUSEACRH:
            return { ...state, lastSKUsearch: action.payload }

        case CRIAVITRINELOADING:
            return { ...state, isLoadingCriaVitrine: action.payload }

        case NOVOCLIENTE_CHANGETAB:
            return { ...state, tabindex: action.payload }

        case CHANGETAB:
            return { ...state, tabindex: action.payload }

        case LISTAPROVACAO:
            return { ...state, aprovacaoList: action.payload }

        case LISTAPROVACAOLOADING:
            return { ...state, aprovacaoListLoading: action.payload }

        case APROVACAOSENDLOADING:
            return { ...state, isLoadingAprovacaoSend: action.payload }

        case ATRIBUTOSLIST:
            return { ...state, atributosList: action.payload }

        case ATRIBUTOSLISTLOADING:
            return { ...state, atributosListLoading: action.payload }

        case ATRIBUTOSITEMLIST:
            return { ...state, atributosItemList: action.payload }

        case ATRIBUTOSITEMLISTLOADING:
            return { ...state, atributosItemListLoading: action.payload }

        case DELETEATRIBUTOSITEMLIST:
            return { ...state, deleteAtributosItemList: action.payload }

        case DELETEATRIBUTOSITEMLISTLOADING:
            return { ...state, deleteAtributosItemListLoading: action.payload }

        case DELETEATRIBUTO:
            return { ...state, deleteAtributo: action.payload }

        case EDITATRIBUTOLOADING:
            return { ...state, editAtributoLoading: action.payload }

        case EDITATRIBUTO:
            return { ...state, editAtributo: action.payload }

        case DELETEATRIBUTOLOADING:
            return { ...state, deleteAtributoLoading: action.payload }

        case POSTATRIBUTOADDNEW:
            return { ...state, postAtributoAddNew: action.payload }

        case POSTATRIBUTOADDNEWLOADING:
            return { ...state, postAtributoAddNewLoading: action.payload }

        case ATRIBUTOSAPLICARLIST:
            return { ...state, atributosAplicarList: action.payload }

        case ATRIBUTOSAPLICARLISTLOADING:
            return { ...state, atributosAplicarListLoading: action.payload }

        case ATRIBUTOSAPLICARGERAL:
            return { ...state, atributosAplicarGeral: action.payload }

        case ATRIBUTOSAPLICARGERALLOADING:
            return { ...state, atributosAplicarGeralLoading: action.payload }

        case ATRIBUTOSAPLICARDELETE:
            return { ...state, atributosAplicarDelete: action.payload }

        case ATRIBUTOSAPLICARDELETELOADING:
            return { ...state, atributosAplicarDeleteLoading: action.payload }

        case ATRIBUTOSAPLICAREDIT:
            return { ...state, atributosAplicarEdit: action.payload }

        case ATRIBUTOSAPLICAREDITLOADING:
            return { ...state, atributosAplicarEditLoading: action.payload }

        case SET_ATRIBUTO_SELECIONADO:
            return { ...state, atributoSelecionado: action.payload };

        case FABRICANTELIST:
            return { ...state, fabricanteList: action.payload }

        case FABRICANTELISTLOADING:
            return { ...state, fabricanteListLoading: action.payload };

        case CLASSIFICACAOLIST:
            return { ...state, classificacaoList: action.payload }

        case CLASSIFICACAOLISTLOADING:
            return { ...state, classificacaoListLoading: action.payload };

        case MARCALIST:
            return { ...state, marcaList: action.payload }

        case MARCALISTLOADING:
            return { ...state, marcaListLoading: action.payload };

        case LINHALIST:
            return { ...state, linhalist: action.payload }

        case LINHALISTLOADING:
            return { ...state, linhalistLoading: action.payload };

        case SECAOLIST:
            return { ...state, secaolist: action.payload }

        case SECAOLISTLOADING:
            return { ...state, secaolistLoading: action.payload };

        case SECAOSKULIST:
            return { ...state, secaoskulist: action.payload }

        case SECAOSKULISTLOADING:
            return { ...state, secaoskulistLoading: action.payload };

        case BUSCASKU:
            return { ...state, buscaSku: action.payload }

        case BUSCASKULOADING:
            return { ...state, buscaSkuLoading: action.payload };

        case BUSCASKULASTSKU:
            return { ...state, buscaSkuLastSku: action.payload };

        case CONTEUDOLIST:
            return { ...state, conteudolist: action.payload }

        case CONTEUDOLISTLOADING:
            return { ...state, conteudolistLoading: action.payload };

        case CONTEUDODETALHES:
            return { ...state, conteudodetalhes: action.payload }

        case CONTEUDODETALHESLOADING:
            return { ...state, conteudodetalhesLoading: action.payload };

        case CONTEUDOBUSCA:
            return { ...state, conteudobusca: action.payload }

        case CONTEUDOBUSCALOADING:
            return { ...state, conteudobuscaLoading: action.payload };

        case CONTEUDOAPLICA:
            return { ...state, conteudoaplica: action.payload }

        case CONTEUDOAPLICALOADING:
            return { ...state, conteudoaplicaLoading: action.payload };

        case UPDATEDESCCONTEUDO:
            return { ...state, updatedesc: action.payload }

        case UPDATEDESCCONTEUDOLOADING:
            return { ...state, updatedescloading: action.payload };

        case UPDATETITULOCONTEUDO:
            return { ...state, updatetitulo: action.payload }

        case UPDATETITULOCONTEUDOLOADING:
            return { ...state, updatetituloloading: action.payload };

        case ADDTITULOCONTEUDO:
            return { ...state, addtitulo: action.payload }

        case ADDTITULOCONTEUDOLOADING:
            return { ...state, addtituloloading: action.payload };

        case DELETETITULOCONTEUDO:
            return { ...state, deletetitulo: action.payload }

        case DELETETITULOCONTEUDOLOADING:
            return { ...state, deletetituloloading: action.payload };

        case APLICARESTLIST:
            return { ...state, aplicarest: action.payload }

        case APLICARESTLISTLOADING:
            return { ...state, aplicarlistloading: action.payload };

        case APLICARESTBUSCALIST:
            return { ...state, aplicarestbusca: action.payload }

        case APLICARESTBUSCALISTLOADING:
            return { ...state, aplicarbuscalistloading: action.payload };

        case APLICARESTAPLICA:
            return { ...state, aplicarestaplica: action.payload }

        case APLICARESTAPLICALOADING:
            return { ...state, aplicarestaplicaloading: action.payload };

        default:
            return state;

    }
}
